export const AUX_CONFIRMED = 'subscription-confirmed'
export const AUX_UNSUBSCRIBED = 'newsletter-unsubscribed'
export const JOINED = 'joined'
export const VERIFIED = 'account-verified'

export const HubTypes = {
  REGULAR: 'regular',
  SPARQ_MEMBER: 'sparq3member',
  SPARQ_STAKEHOLDER: 'sparq3stakeholder',
}

export const HUB_COVER_HEIGHT = 480
export const HUB_STICKY_HEADER_HEIGHT = 50
export const HUB_STICKY_FOOTER_HEIGHT = 40
